/* tslint:disable */
/* eslint-disable */
/**
 * Magnolia Headless Helper API
 * Helper API and model definitions for breadcrumbs page navigation etc. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
* 
* @export
* @interface ApiFormSubmitResponse
*/
export interface ApiFormSubmitResponse {
    /**
    * 
    * @type {boolean}
    * @memberof ApiFormSubmitResponse
    */
    result?: boolean;
    /**
    * 
    * @type {string}
    * @memberof ApiFormSubmitResponse
    */
    redirectUrl?: string;
}

export function ApiFormSubmitResponseFromJSON(json: any): ApiFormSubmitResponse {
return ApiFormSubmitResponseFromJSONTyped(json, false);
}

export function ApiFormSubmitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFormSubmitResponse {
    if ((json === undefined) || (json === null)) {
    return json;
    }
    return {
    
                    'result': json['result'],
                    'redirectUrl': json['redirectUrl'],
        };
    }

    export function ApiFormSubmitResponseToJSON(value?: ApiFormSubmitResponse | null): any {
    if (value === undefined) {
    return undefined;
    }
    if (value === null) {
    return null;
    }
    return {

                'result': value.result,
                'redirectUrl': value.redirectUrl,
    };
    }


    // custom code here ##################################################################################################################
    // function toUTC(date) {
    //   var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    //   return new Date(date_utc);
    // }

